import { MedicationModel } from "app/services/api/types/medications/models/MedicationModel";
import { FC } from "react";
import { View } from "react-native";
import { Button, ButtonIcon, ButtonText } from "ui/gluestack/button";
import { EditIcon, SlashIcon } from "ui/gluestack/icon";

interface Props {
  medication: MedicationModel;
  onEdit?: (medication: MedicationModel) => void;
  onDiscontinue?: (medication: MedicationModel) => void;
  onAddNoteOrVoid?: (medication: MedicationModel) => void;
}

export const MedicationActionButtons: FC<Props> = ({
  medication,
  onEdit,
  onDiscontinue,
  onAddNoteOrVoid,
}) => {
  return (
    <View className={"flex flex-row  gap-x-3 lg:gap-x-8 self-center"}>
      {onEdit ? (
        <Button
          size="sm"
          variant="link"
          onPress={() => onEdit(medication)}
          className="px-2 lg:px-0"
        >
          <ButtonText className="hidden xl:block">Edit</ButtonText>

          <ButtonIcon as={EditIcon} />
        </Button>
      ) : null}
      {onDiscontinue ? (
        <>
          <Button
            size="sm"
            variant="link"
            action="negative"
            onPress={() => onDiscontinue(medication)}
          >
            <ButtonText className="hidden xl:block">Discontinue</ButtonText>
            <ButtonIcon as={SlashIcon} />
          </Button>
        </>
      ) : null}
      {onAddNoteOrVoid ? (
        <Button
          size="sm"
          variant="link"
          onPress={() => onAddNoteOrVoid(medication)}
          className="px-2 lg:px-0"
        >
          <ButtonText className="hidden xl:block">Modify log</ButtonText>

          <ButtonIcon as={EditIcon} />
        </Button>
      ) : null}
    </View>
  );
};
